import Translator from '../requests/apa/Translator'
import Asset from "../requests/apa/Asset";
import Utils from './Utils'


class UtilsProfile {

  static getAdminMember(items) {

    const admins = items.filter((item) => item.data.admin === true);
    return admins && admins[0] ? admins[0] : null;

  }

  static validateForm(validateFields, onFieldError) {

    let isValid = true;

    for (let field in validateFields) {

      let message = '';

      if (this.validateField(validateFields[field].value.trim(), validateFields[field].regExp)) {
        validateFields[field].hasError = false;
      }
      else {
        isValid = false;
        validateFields[field].hasError = true;

        switch (validateFields[field].name) {
          case 'firstName':
            message = Translator.get('perfiles_nombre_error_gen', 'Valor obligatorio. Al menos 2 caracteres');
            break;
          default:
            message = Translator.get('perfiles_nombre_error_gen', 'Selecciona una imagen ...');
            break;
        }

      }
      validateFields[field].error = message;
    }

    onFieldError(validateFields);
    return isValid;

  }

  static validateField(field, regExp) {

    if (!Utils.isString(field) || field === '')
      return false;

    return (regExp.test(field));

  }

  static getField(fields, inputName){
    let inputField = fields.filter(field => field.name === inputName);
    inputField = inputField[0] ? inputField[0] : {};
    return inputField;
  }

  static getAddAvatar() {
    return Asset.get('ic_add_profile', '/images/profile_img_add.png');
  }

  static isSocialConfigEnable() {
    //return Utils.getAPARegionalized('social_config', 'enable', false) === true;
    return Utils.getApaMetadataKey('social_config','{"enable": false}','enable') === true;

  }

  static isProfilesConfigEnable() {

    return Utils.getApaMetadataKey('profiles_config', '{"enable": false}', 'enable') === true;

  }

  static isProfileEnable(user) {

    return this.isProfilesConfigEnable();

  }

  static setFocus(querySelector) {
    setTimeout(() => {
      window.SpatialNavigation.focus(querySelector);
    }, 100)
  }

  static changeProtocolURLImage(url) {
    const isPS4 = Utils.isPlaystation4()
    const isCoship = Utils.isSTBCoship()
    const isTizen = Utils.isTizen()
    if ((isPS4 || isCoship || isTizen) && url) {
      return url.replace('https://', 'http://');
    }
    return url;
  }

}

export default UtilsProfile;



// WEBPACK FOOTER //
// ./src/utils/Profile.js